import { useState, useRef } from 'react';
import { Button, Icon, ActionsMenu, ActionsMenuItem } from '@repo/ui';

export type ExportFormat = 'pdf' | 'csv' | 'excel';

export interface ExportButtonProps {
  onExport: (format: ExportFormat) => void;
  disabled?: boolean;
  loading?: boolean;
}

export function ExportButton({ onExport, disabled = false, loading = false }: ExportButtonProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleExport = (format: ExportFormat) => {
    setIsMenuOpen(false);
    onExport(format);
  };

  return (
    <div className="relative">
      <Button
        ref={buttonRef}
        variant="primary"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        disabled={disabled || loading}
        loading={loading}
        leftIcon={<Icon name="HiDownload" className="h-4 w-4" />}
        rightIcon={<Icon name="HiChevronDown" className="h-4 w-4" />}
      >
        Export
      </Button>

      <ActionsMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        triggerElement={buttonRef.current}
      >
        <ActionsMenuItem
          icon="HiDocumentText"
          label="Export as PDF"
          onClick={() => handleExport('pdf')}
          disabled={disabled || loading}
        />
        <ActionsMenuItem
          icon="HiDocument"
          label="Export as CSV"
          onClick={() => handleExport('csv')}
          disabled={disabled || loading}
        />
        {/* <ActionsMenuItem
          icon="HiTable"
          label="Export as Excel"
          onClick={() => handleExport('excel')}
          disabled={disabled || loading}
        /> */}
      </ActionsMenu>
    </div>
  );
}
